export function range(n, humanMode = false) {
    return Array.apply(null, { length: n }).map(
        (n, i) => (humanMode ? i + 1 : i),
        Number
    );
}
